import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconSort = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
    <path
      d="M16.6667 5L3.33342 5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14.1667 10H5.83341"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.6667 15H8.33341"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </SvgIcon>
)
